// extracted by mini-css-extract-plugin
export default {"responsiveContainer":"FunnelView_responsiveContainer__Ur6+D","backButton":"FunnelView_backButton__9zpKi"};